/* eslint-disable react/jsx-props-no-spreading */
import {
    useMemo,
} from 'react'
import {
    Typography,
} from '@mui/material'
import clsx from 'clsx'

import useStyles from './Label.style'

const defaultProps = {
    className: '',
    hasError: '',
}

const Label = ({
    title,
    className,
    hasError,
}: {
    title: string,
    className?: string,
    hasError?: string
}) => {
    const {
        classes,
    } = useStyles()

    const typographyProps = useMemo(() => {
        const tProps = {
            classes: {
                root: clsx(classes.label, className),
            },
            color: hasError ? 'error' : undefined,
        }

        return tProps
    }, [
        className,
        classes.label,
        hasError,
    ])

    return (
        <Typography
            {...typographyProps}
            data-testid={`label-${title}`}
        >
            {title}
        </Typography>
    )
}

Label.defaultProps = defaultProps

export default Label
